import { HOST, } from "common/constants";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Typography } from "@mui/material";
import { Element } from "react-scroll";
import { useTranslation } from "react-i18next";

import { SkeletonCard } from "components/SkeletonCard";
import Empty from "components/Empty/Empty";

 

import classes from "./team.module.scss";
import GovernanceGroup from "./GovernanceGroup";
import AuditCommissionGroup from "./AuditCommissionGroup";
import ManagementGroup from "./ManagementGroup";

const TeamList = () => {
  const { t, i18n } = useTranslation();
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);

  const getTranslatedField = (employee, field) => {
    const lang = i18n.language;
    return employee[`${field}_${lang}`] || employee[field] || "";
  };

  useEffect(() => {
    const fetchEmployees = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${HOST}/api/v1/employees/`, {
          params: { limit: 1000 },
        });
        const data = response.data.results || [];
        setEmployees(data);
      } catch (error) {
        console.error("Ошибка при получении сотрудников:", error);
        setEmployees([]);
      } finally {
        setLoading(false);
      }
    };

    fetchEmployees();
  }, [i18n.language]);

  if (loading) {
    return (
      <>
        <Element name="ourTeam" />
        <Typography className={classes.title}>{t("ourTeamAboutUs")}</Typography>
        <Box className={classes.teamList}>
          {Array.from({ length: 6 }).map((_, idx) => (
            <SkeletonCard key={idx} />
          ))}
        </Box>
      </>
    );
  }

  if (employees.length === 0) {
    return (
      <>
        <Element name="ourTeam" />
        <Typography className={classes.title}>{t("ourTeamAboutUs")}</Typography>
        <Empty />
      </>
    );
  }

  return (
    <>
      <Element name="ourTeam" />
      <Typography className={classes.title}>{t("ourTeamAboutUs")}</Typography>

      <GovernanceGroup
        employees={employees}
        getTranslatedField={getTranslatedField}
        classes={classes}
      />

      <AuditCommissionGroup
        employees={employees}
        getTranslatedField={getTranslatedField}
        classes={classes}
      />

      <ManagementGroup
        employees={employees}
        getTranslatedField={getTranslatedField}
        classes={classes}
      />
    </>
  );
};

export default TeamList;